import { FC } from 'react';
import { LessonEditStatusReasonDetail } from '../../../types/planung-graphql-client-defs';

type EditStatusTooltipContentProps = {
  // Server-seitig vorberechnet + lokalisiert (reason.label = Satz-Stamm, reference.label = Plan/Version).
  reasons: LessonEditStatusReasonDetail[];
};

export const EditStatusTooltipContent: FC<EditStatusTooltipContentProps> = ({ reasons }) => {
  if (!reasons || reasons.length === 0) {
    return null;
  }

  return (
    <div>
      {reasons.map((reason, index) => (
        <div key={`${reason.reason}-${index}`} className={index > 0 ? 'mt-2' : undefined}>
          <div>{reason.label}</div>
          {reason.references.length > 0 && (
            <ul>
              {reason.references.map((reference) => (
                <li key={`${reference.planUuid}-${reference.versionUuid ?? ''}`}>{reference.label}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};
